import { FallbackLoader } from "components/UI/molecules";
import { ChangePasswordForm } from "components/UI/organisms";
import { ReactHelmetWithProvider } from "providers/ReactHelmetProvider";
import { INTERNAL_PATHS } from "routes/paths";
import { useCanChangePassword } from "./utils/useCanChangePassword";
import "./index.scss";

export const ChangePassword = () => {
  const { isLoading } = useCanChangePassword();
  return (
    <>
      <ReactHelmetWithProvider>
        <title>Change Password - GCX</title>
        <link
          href={window.location.origin + INTERNAL_PATHS.CHANGE_PASSWORD}
          rel="canonical"
        />
      </ReactHelmetWithProvider>

      {isLoading ? (
        <FallbackLoader />
      ) : (
        <div className="change-password-container">
          <h1 className="page-title">Change my password</h1>

          <ChangePasswordForm />
        </div>
      )}
    </>
  );
};
